/**
 * @file Benefits.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Benefits component.
 */
const vBenefits = () => {
	const benefits = document.querySelector('.v-benefits');

	if (!benefits) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const html = document.querySelector('html');
	const inner = benefits.querySelector('.v-benefits__inner');
	const images = benefits.querySelectorAll('.v-benefits__image');

	ScrollTrigger.saveStyles([...images, html]);

	ScrollTrigger.matchMedia({
		'(min-width: 601px)': () => {
			gsap.to(html, {
				backgroundColor: '#000',
				ease:            'sine.out',
				scrollTrigger:   {
					trigger: inner,
					start:   '15% bottom',
					end:     '60% bottom',
					scrub:   true,
				},
			});

			gsap.to(images, {
				yPercent:      (i) => (((2 - i) / 2) * 50) + 50,
				ease:          'sine.out',
				scrollTrigger: {
					trigger: inner,
					start:   'top bottom',
					end:     'bottom top',
					scrub:   true,
				},
			});
		},
	});
};

export default vBenefits;
